import { Flex, FormatNumber, Text, TextProps } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useI18nLn } from '~/hooks/store';

export const TotalAmountContainer: React.FC<{
  totalAmount: number;
  visual: 'subtotal' | 'total';
  title?: string;
}> = (props) => {
  const { t } = useI18nLn();

  const amountTextProps: TextProps = useMemo(() => {
    if (props.visual === 'subtotal') {
      return { fontSize: 28 };
    }
    return { fontSize: 32, fontWeight: 'bold' };
  }, [props.visual]);

  return (
    <Flex justify="space-between" align="baseline" w="100%">
      <Flex align="baseline">
        <Text fontSize="13px">
          {props?.title != null ? props.title : t('global.common.sum')}
        </Text>
        <Text fontSize="11px">({t('global.common.tax.included')})</Text>
      </Flex>
      <Flex align="baseline">
        <Text fontSize="18px">&yen;</Text>
        <Text lineHeight="48px" {...amountTextProps}>
          <FormatNumber value={props.totalAmount} />
        </Text>
      </Flex>
    </Flex>
  );
};
